import swal from 'sweetalert';

export default function () {
    let previousWindowKeyDown = window.onkeydown;
    swal.apply(this, Array.prototype.slice.call(arguments, 0));
    window.onkeydown = previousWindowKeyDown;
}



// WEBPACK FOOTER //
// ./app/components/common/swal/swal.js